module.exports = __webpack_public_path__ + "img/addr-orange.ba6b0e6a.png";